export class ChangeOrganizationFolderDialogConfiguration {
  constructor(
    public actionTitle: string,
    public originalName: string,
    public newName: string
  ) {}
}
